import {connection} from './state';

/**
 * Establecer un valor para la variable connections.
 */
export function setConnections(state, connections) {
    state.connections = connections;
}

/**
 * Establecer un valor para el atributo show de la variable modal.
 */
export function setModalShow(state, show) {
    state.modal.show = show;
}

/**
 * Establecer un valor para la variable connection.
 */
export function setConnection(state, connection) {
    state.connection = JSON.parse(JSON.stringify(connection));
}

/**
 * Establecer el valor por defecto para la variable connection.
 */
export function resetConnection(state) {
    state.connection = connection();
}

/**
 * Establecer un valor para la variable test_result.
 */
export function setTestResult(state, test_result) {
    state.test_result = test_result;
}

/**
 * Establecer un valor para la variable testing_connection.
 */
export function setTestingConnection(state, testing_connection) {
    state.testing_connection = testing_connection;
}
